import React from 'react'
import { Link } from 'react-router-dom';

const Header_for_mobile = () => {
  return (
   <div>
    <div className="w-full h-20 bg-gradient-to-r from-blue-500 to-blue-300 text-black flex items-center justify-center shadow-md text-xl" style={{ fontFamily: 'Lato, sans-serif' }}>
        <h1>
            The Great Himalayas
        </h1>
          <Link to="/careers" className="text-sm text-black underline ml-[85px] sm:ml-[450px]" style={{ fontFamily: 'Lato, sans-serif' }}>
          Join Us
        </Link> 
    </div>
   </div>
  )
}

export default Header_for_mobile;